export default __webpack_public_path__ + "static/media/notFound.88ea9106.jpg";